var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Card, CardContent, Typography } from '@material-ui/core';
import * as classNames from 'classnames';
import Animate from '../../../theme/components/Animate';
import TextFieldFormsy from '../../../theme/components/TextFieldFormsy';
import Formsy from 'formsy-react';
import axios from 'axios';
var isDevStage = window.location.href.indexOf('localhost') !== -1 ||
    window.location.href.indexOf(':3000') !== -1 ||
    window.location.href.indexOf('tt-react-dev') !== -1 ||
    window.location.href.indexOf('tt-react-test') !== -1 ||
    window.location.href.indexOf('.dev.trainingtube.com') !== -1;
var styles = function () { return ({
    root: {
        background: "url('/assets/images/backgrounds/background.jpg') no-repeat",
        backgroundSize: 'cover',
        width: '100%',
        height: '100%',
        '@media(max-width: 767px)': {
            padding: '0 !important',
        },
    },
    intro: {
        color: '#ffffff',
        '@media(max-width: 767px)': {
            display: 'none !important',
        },
    },
    card: {
        width: '100%',
        maxWidth: 400,
        height: '100%',
        minHeight: 700,
        '@media(max-width: 767px)': {
            maxWidth: '100%',
            margin: '0 !important',
        },
    },
    logoImg: {
        position: 'absolute',
        bottom: 75,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '@media(max-width: 767px)': {
            bottom: 40,
        },
        '& img': {
            width: 300,
        },
    },
}); };
// @ts-ignore
var RootLogin = /** @class */ (function (_super) {
    __extends(RootLogin, _super);
    function RootLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            canSubmit: false,
        };
        _this.form = React.createRef();
        _this.disableButton = function () {
            _this.setState({ canSubmit: false });
        };
        _this.enableButton = function () {
            _this.setState({ canSubmit: true });
        };
        _this.onSubmit = function (model) { return __awaiter(_this, void 0, void 0, function () {
            var data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios({
                                method: 'GET',
                                url: this.props.apiUrl + "/getOrgId",
                                params: {
                                    email: model.username,
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        localStorage.setItem('lastOrgId', data.orgId);
                        window.location.href = "https://" + data.orgId + ".trainingtube.com/login?email=" + model.username;
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        // @ts-ignore
                        this.form.updateInputsWithError({
                            username: 'This email does not belong to any organization',
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    RootLogin.prototype.componentDidMount = function () {
        var lastOrgId = localStorage.getItem('lastOrgId');
        if (lastOrgId) {
            window.location.href = "https://" + lastOrgId + ".trainingtube.com/login";
        }
        if (isDevStage)
            return;
        var scriptEl = document.createElement('script');
        var noScriptEl = document.createElement('noscript');
        var imgEl = document.createElement('img');
        scriptEl.innerHTML = "\n      !function(f,b,e,v,n,t,s)\n      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n      n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n      n.queue=[];t=b.createElement(e);t.async=!0;\n      t.src=v;s=b.getElementsByTagName(e)[0];\n      s.parentNode.insertBefore(t,s)}(window, document,'script',\n      'https://connect.facebook.net/en_US/fbevents.js');\n      fbq('init', '432949744083181');\n      fbq('track', 'PageView');\n    ";
        imgEl.src = 'https://www.facebook.com/tr?id=432949744083181&ev=PageView&noscript=1';
        imgEl.height = 1;
        imgEl.width = 1;
        imgEl.hidden = true;
        noScriptEl.appendChild(imgEl);
        document.body.appendChild(scriptEl);
        document.body.appendChild(noScriptEl);
    };
    RootLogin.prototype.render = function () {
        var _this = this;
        var classes = this.props.classes;
        var canSubmit = this.state.canSubmit;
        return (React.createElement("div", { className: classNames(classes.root, 'flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0'), style: {
                background: "url('/assets/images/backgrounds/background.jpg') no-repeat",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            } },
            React.createElement("div", { className: classNames(classes.intro, 'flex flex-col flex-no-grow items-center p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left') }),
            React.createElement(Animate, { animation: "transition.expandIn" },
                React.createElement(Card, { className: classNames(classes.card, 'mx-auto m-16 md:m-0') },
                    React.createElement(CardContent, { className: "flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 " },
                        React.createElement(Typography, { variant: "title", className: "md:w-full mb-32" }, "Login to organization"),
                        React.createElement(Formsy, { onValidSubmit: this.onSubmit, onValid: this.enableButton, onInvalid: this.disableButton, ref: function (form) {
                                _this.form = form;
                            }, className: "flex flex-col justify-center w-full" },
                            React.createElement(TextFieldFormsy, { id: "email", className: "mb-16", type: "email", name: "username", label: "Email", required: true }),
                            React.createElement(Button, { type: "submit", variant: "raised", color: "primary", className: "w-full mx-auto mt-16 normal-case", "aria-label": "LOG IN", disabled: !canSubmit, value: "legacy", name: "Login", id: "login-button" }, "Login")),
                        React.createElement("div", { className: classes.logoImg },
                            React.createElement(Typography, { variant: "subheading" }, "Powered by"),
                            React.createElement("img", { src: "./assets/images/launchpeople-logo-venstre-lilla-screen_p.jpg" })))))));
    };
    RootLogin = __decorate([
        withStyles(styles, { withTheme: true })
    ], RootLogin);
    return RootLogin;
}(React.PureComponent));
export default RootLogin;



//////////////////
// WEBPACK FOOTER
// ./src/components/routes/root-login/index.tsx
// module id = 1503
// module chunks = 81